<app-header></app-header>

<div class="monitoring-section">
  <div class="container monitoring-heading">
    <div class="row">
      <div class="col-4">
        <h2>Monitoring</h2>
      </div>
      <div class="col-4"></div>
      <div class="col-4">
        <div class="form-group">
          <p>Select account number:</p>
          <select
            id="accountnumber-select"
            class="form-control"
            [(ngModel)]="selectedAccountNumber"
            (change)="fetchDataAndRenderChart(selectedAccountNumber)"
          >
            <option *ngFor="let v of accountNumbers" [value]="v">
              {{ v }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <hr />
    <ul class="nav nav-tabs justify-content-end" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link active"
          id="billing-tab"
          data-bs-toggle="tab"
          data-bs-target="#billing"
          type="button"
          role="tab"
          aria-controls="billing"
          aria-selected="true"
        >
          Billed Production
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          id="production-tab"
          data-bs-toggle="tab"
          data-bs-target="#production"
          type="button"
          role="tab"
          aria-controls="production"
          aria-selected="false"
        >
          Metered Production
        </button>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div
        class="tab-pane fade show active"
        id="billing"
        role="tabpanel"
        aria-labelledby="billing-tab"
      >
        <div class="row mt-5">
          <div class="col-12 col-md-12 col-lg-3 text-center">
            <img src="/assets/graph-icon.png" alt="images" />
          </div>
          <div class="col-12 col-md-12 col-lg-9">
            <div style="width: 100%">
              <div class="text-center" *ngIf="isLoadingVisible">
                <div
                  class="spinner-border text-primary loading-spinner"
                  role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>

              <div
                class="graph-error"
                *ngIf="!isChartVisible && !isLoadingVisible"
              >
                <h5 class="text-center mb-0">Usage not found for this user</h5>
              </div>
              <div
                class="download-button text-end"
                *ngIf="isChartVisible && !isLoadingVisible"
              >
                <a (click)="downloadCSV()">Download as CSV</a>
              </div>
              <div>
                <canvas id="canvas">{{ chart }}</canvas>
              </div>
              <p class="right-text mt-5 mb-5">
                *Please note the graph shows either (a) actual production
                reported by your meter or (b) estimated production, as
                determined by your solar power agreement, in situations where
                the meter is not communicating or otherwise allowed under the
                agreement
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        id="production"
        role="tabpanel"
        aria-labelledby="production-tab"
      >
        <div class="row mt-5">
          <div class="col-12 col-md-12 col-lg-3 text-center">
            <img src="/assets/graph-icon.png" alt="images" />
          </div>
          <div class="col-12 col-md-12 col-lg-9">
            <div style="width: 100%">
              <div class="text-center" *ngIf="isLoadingVisible">
                <div
                  class="spinner-border text-primary loading-spinner"
                  role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>

              <div
                class="graph-error"
                *ngIf="!isChartVisible && !isLoadingVisible"
              >
                <h5 class="text-center mb-0">Usage not found for this user</h5>
              </div>
              <div
                class="download-button text-end"
                *ngIf="isChartVisible && !isLoadingVisible"
              >
                <a (click)="downloadCSV()">Download as CSV</a>
              </div>
              <div>
                <canvas id="canvas_Production">{{ chart }}</canvas>
              </div>
              <p class="right-text mt-5 mb-5">
                *Please note the graph shows the metered production data
                reported to us by your solar system. A low value does not
                necessarily mean your system is not producing power and may
                require troubleshooting your meter. Please contact HOST at
                <a href="tel:+18886360336">(888)636-0336</a> if you have questions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
